import DashboardFPPTBarChart from '@app/components/charts/DashboardFPPTBarChart';
import React from 'react';
import DashboardSection from './dashboard-section';

interface AverageLifeCycleEmissionsInterface {
  averageLifeCycleStageEmissionsPerKg: {
    lifeCycleStage: string;
    emissions: number;
  }[];
}

const AverageLifeCycleEmissions: React.FC<
  AverageLifeCycleEmissionsInterface
> = ({ averageLifeCycleStageEmissionsPerKg }) => {
  return (
    <DashboardSection
      title="Average Life Cycle Emissions (per kg)"
      tooltipContent="Average Life Cycle Emissions"
    >
      <div className="flex h-[350px] w-full items-center justify-center rounded-md bg-gray-00">
        <DashboardFPPTBarChart
          chartLayout="vertical"
          averageLifeCycleStageEmissionsPerKg={
            averageLifeCycleStageEmissionsPerKg
          }
        />
      </div>
    </DashboardSection>
  );
};

export default AverageLifeCycleEmissions;
